import axios from 'axios';

export async function get_Token(req) {

    try {
        let data = '';
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${req.url}authrization.php`,
            headers: {
                'Authorization': 'Bearer 5d7660dd98303a0b4e'
            },
            data: data
        };

        const res = await axios.request(config)
        return await res?.data;


    }
    catch (err) {
    
        return await err;
    }
}

export async function getAllClient(data, url ,token) {


    try {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${url}getRecords.php`,
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: data
        };


        const res = await axios.request(config)
        return await res?.data;


    }
    catch (err) {
  
        return await err;
    }
}

export async function getClientDetails(data, url ,token) {

    try {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${url}getRecordDetails.php`,
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: data
        };

        const res = await axios.request(config)
        return await res?.data;


    }
    catch (err) {
        console.log("getRecordDetails Error",err);
        return await err;
    }
}
